function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Lock",
  transform: "translate(-3203 -161)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Layer1",
  "data-name": "Ellipse 284",
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(3203 166)",
  fill: "#c7c7c7"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Layer2",
  "data-name": "Ellipse 283",
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(3203 161)",
  fill: "#dbdbdb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Lock",
  "data-name": "lock",
  d: "M10.678,5.98h-.641V4.058a4.058,4.058,0,1,0-8.116,0V5.98H1.281A1.282,1.282,0,0,0,0,7.261v5.126a1.282,1.282,0,0,0,1.281,1.281h9.4a1.282,1.282,0,0,0,1.281-1.281V7.261A1.282,1.282,0,0,0,10.678,5.98ZM7.9,5.98H4.058V4.058a1.922,1.922,0,1,1,3.844,0Z",
  transform: "translate(3213 170.5)"
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 37,
  viewBox: "0 0 32 37"
}, props), _ref);

export default __webpack_public_path__ + "static/media/HexagonLock.2702e527.svg";
export { SvgComponent as ReactComponent };